import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Col,
  Button,
  ViewIcon,
  Sheet,
  LoadingSpinner,
} from '@paypalcorp/pp-react';
import CommonPreviewComponent from './CommonPreviewComponent';
import {
  isDonateButton,
  isTablet,
  isDonateLink,
  isHostedFlow,
} from '../../utilsV3/buttonFactoryUtils';
import ButtonFactoryV3DesktopPreview from './ButtonFactoryV3DesktopPreview';
import WizardStep1Preview from './WizardStep1Preview';
import WizardDisclaimer from '../../shared/WizardDisclaimer';

function WizardMobilePreview({
  handleSubmit,
  openMobilePreview,
  isMobilePreviewOpen,
  closeMobilePreview,
  usePaypalButtonStyle,
  buttonSize,
  showAcceptedCardLogos,
  buttonImageUrl,
  onError,
  locale,
  country,
  steps: { currentStep, totalSteps },
  labels: { continueButton, finishButton, previewButton, previewTitle },
  showSpinner,
  buttonDropzoneSubmit,
  handleBannerAndLogoErrorCheck,
  frequencies,
  recurringEnabled,
}) {
  const userConsentData = useSelector(
    (state) => state.application.userConsentData
  );

  const draftBusy = useSelector(
    (state) => state?.buttonFactoryV3?.draftBusy || false
  );

  function renderPreview() {
    const isMobile = !isTablet();
    if (currentStep === 1 && isDonateButton()) {
      return (
        <WizardStep1Preview
          usePaypalButtonStyle={usePaypalButtonStyle}
          buttonSize={buttonSize}
          showAcceptedCardLogos={!!showAcceptedCardLogos}
          buttonImageUrl={buttonImageUrl}
          onError={onError}
          locale={locale}
          country={country}
          isMobile={true}
        />
      );
    }
    return isMobile ? (
      <CommonPreviewComponent isMobile={isMobile} />
    ) : (
      <ButtonFactoryV3DesktopPreview />
    );
  }

  const handleButtonClick = () => {
    if (currentStep === 1) {
      if (isDonateLink()) {
        const res = handleBannerAndLogoErrorCheck();
        if (res) {
          handleSubmit();
        }
      } else {
        buttonDropzoneSubmit();
      }
    } else if (currentStep === 2 && isHostedFlow()) {
      if (isDonateButton()) {
        const res = handleBannerAndLogoErrorCheck();
        if (res) {
          handleSubmit();
        }
      }
      if (isDonateLink()) {
        if (frequencies.length > 0 && frequencies.length < 3) {
          handleSubmit();
        }
      }
    } else if (currentStep === 3 && recurringEnabled === 'yes') {
      if (frequencies.length > 0 && frequencies.length < 3) {
        handleSubmit();
      }
    } else {
      handleSubmit();
    }
  };

  return (
    <>
      <Col lg="12" className="mobilePreview">
        {userConsentData?.consentNeeded && currentStep === totalSteps && (
          <div className="mobilePreviewConsent">
            <WizardDisclaimer isButton={true} />
          </div>
        )}
        {draftBusy ? (
          <LoadingSpinner
            data-testid="save-draft-spinner"
            size="lg"
            className="loader"
          />
        ) : (
          <Button
            className="next"
            type="submit"
            onClick={handleButtonClick}
            btnState={showSpinner ? 'processing' : 'initial'}
          >
            {currentStep === totalSteps ? finishButton : continueButton}
          </Button>
        )}
        <Button
          tertiary
          className="button-link previewButton"
          onClick={openMobilePreview}
        >
          <ViewIcon />
          {previewButton}
        </Button>
      </Col>
      <Sheet
        isOpen={isMobilePreviewOpen}
        onClose={closeMobilePreview}
        title={previewTitle}
        mobileFixedHeight="90"
        className="mobilePreview darkBackground"
        wrapperClassName="mobilePreview-wrapper"
        skipFormFocus={true}
      >
        {renderPreview()}
      </Sheet>
    </>
  );
}

WizardMobilePreview.propTypes = {
  handleSubmit: PropTypes.func,
  openMobilePreview: PropTypes.func,
  isMobilePreviewOpen: PropTypes.bool,
  closeMobilePreview: PropTypes.func,
  steps: PropTypes.object,
  labels: PropTypes.object,
  usePaypalButtonStyle: PropTypes.bool,
  buttonSize: PropTypes.string,
  showAcceptedCardLogos: PropTypes.bool,
  buttonImageUrl: PropTypes.string,
  onError: PropTypes.func,
  locale: PropTypes.string,
  country: PropTypes.string,
  showSpinner: PropTypes.bool,
  buttonDropzoneSubmit: PropTypes.func,
  handleBannerAndLogoErrorCheck: PropTypes.func,
  frequencies: PropTypes.array,
  recurringEnabled: PropTypes.string,
};

export default WizardMobilePreview;
